import List from '../../containers/SalaryInfos/List';
import Edit from '../../containers/SalaryInfos/Edit';
import Create from '../../containers/SalaryInfos/Create';
import Show from '../../containers/SalaryInfos/Show';

export default { List, Edit, Create, Show };
